<div class="admin-nav-wrapper">
  <div class="content-wrapper">
    <ng-content></ng-content>
  </div>
</div>
